import {
  type ErrorPageProps,
  executeInitialPropsGuards,
} from '../helper/executeInitialPropsGuards';
import { generateErrorPageGuards } from './account/generateErrorPageGuards';
import { ERROR_PAGE_DEFAULT_STATE } from './account/state';

import type { NextPageContext } from 'next';

export const getInitialPropsAccountWrapper = () => {
  const guards = generateErrorPageGuards();

  return async (context: NextPageContext): Promise<ErrorPageProps> => {
    return executeInitialPropsGuards({
      context,
      guards,
      state: ERROR_PAGE_DEFAULT_STATE,
    });
  };
};
